import { TableCell, Typography } from '@mui/material';
import { omit } from 'ramda';
import { ICourse } from '@shared';
import { ViewLink } from '.';
import { RouteEnum } from 'App';

type TypeProps = {
  item: ICourse;
  partners?: { label: string; id: string }[];
  isMultiplePartners: boolean;
  pathname: string;
  closeModal: () => void;
};

export function CourseCell({
  item,
  partners,
  isMultiplePartners,
  pathname,
  closeModal,
}: TypeProps) {
  const { partnerUuid, courseUuid, ...rest } = omit(['uuid'], item);
  const to = `${RouteEnum.Partners}/${partnerUuid}/courses/${courseUuid}/exams`;
  const onClose = pathname === to ? closeModal : () => null;

  return (
    <>
      {isMultiplePartners && partners && (
        <TableCell size='small'>
          <Typography component='span' variant='tableCell'>
            {partners.find(({ id }) => id === partnerUuid)?.label}
          </Typography>
        </TableCell>
      )}
      {Object.values(rest).map((i, index) => (
        <TableCell size='small' key={index}>
          <Typography component='span' variant='tableCell'>
            {i as string}
          </Typography>
        </TableCell>
      ))}
      <ViewLink to={to} onClick={onClose} />
    </>
  );
}
